import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsEsphomeComponent } from './simple-icons-esphome.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsEsphomeComponent ],
    exports:      [ SimpleIconsEsphomeComponent ],
    bootstrap:    []
})
export class SimpleIconsEsphomeModule {}
